import { render } from "./Todo.vue?vue&type=template&id=48f3a78d&scoped=true&bindings={}"
import script from "./Todo.vue?vue&type=script&lang=js"
export * from "./Todo.vue?vue&type=script&lang=js"

import "./Todo.vue?vue&type=style&index=0&id=48f3a78d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48f3a78d"

export default script